import { render } from "./MemberEdit.vue?vue&type=template&id=5035b5ec"
import script from "./MemberEdit.vue?vue&type=script&lang=js"
export * from "./MemberEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__